import React, { Component } from 'react'
import { Table, Button, Tooltip, Input, Icon, Tag } from 'antd'
import API from '../../../services/API'

class InventoryEntryReport extends Component {
	state = {
		data: [],
		loading: true,
		pagination: {},
		searchText: '',
		filters: {
			name: ''
		}
	}

	componentDidMount() {
		this.getData({
			page: 1
		})
	}

	handleSearch = (selectedKeys, confirm, column) => {
		confirm()
	}

	handleReset = clearFilters => {
		clearFilters()
	}

	// getColumnSearchProps = dataIndex => ({
	// 	filterDropdown: ({
	// 		setSelectedKeys,
	// 		selectedKeys,
	// 		confirm,
	// 		clearFilters
	// 	}) => (
	// 		<div style={{ padding: 8 }}>
	// 			<Input
	// 				ref={node => {
	// 					this.searchInput = node
	// 				}}
	// 				placeholder={`Search ${dataIndex}`}
	// 				value={selectedKeys[0]}
	// 				onChange={e =>
	// 					setSelectedKeys(e.target.value ? [e.target.value] : [])
	// 				}
	// 				onPressEnter={() =>
	// 					this.handleSearch(selectedKeys, confirm)
	// 				}
	// 				style={{ width: 188, marginBottom: 8, display: 'block' }}
	// 			/>
	// 			<Button
	// 				type="primary"
	// 				onClick={() => this.handleSearch(selectedKeys, confirm)}
	// 				icon="search"
	// 				size="small"
	// 				style={{ width: 90, marginRight: 8 }}
	// 			>
	// 				Search
	// 			</Button>
	// 			<Button
	// 				onClick={() => this.handleReset(clearFilters)}
	// 				size="small"
	// 				style={{ width: 90 }}
	// 			>
	// 				Reset
	// 			</Button>
	// 		</div>
	// 	),
	// 	filterIcon: filtered => (
	// 		<Icon
	// 			type="search"
	// 			style={{ color: filtered ? '#1890ff' : undefined }}
	// 		/>
	// 	),
	// 	onFilterDropdownVisibleChange: visible => {
	// 		if (visible) {
	// 			setTimeout(() => this.searchInput.select())
	// 		}
	// 	}
	// 	// render: text => (
	// 	//     <Highlighter
	// 	//         highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
	// 	//         searchWords={[this.state.searchText]}
	// 	//         autoEscape
	// 	//         textToHighlight={text.toString()}
	// 	//     />
	// 	// )
	// })

	getData = ({ page = 1, filters = null, sorter = null }) => {
		let query = ''

		if (filters) {
			const keys = Object.keys(filters)

			keys.forEach(k => {
				if (filters[k].length) {
					query += `&filter[${k}]=${filters[k][0]}`
				}
			})
		}

		if (sorter && Object.keys(sorter).length) {
			const order = sorter.order === 'descend' ? '-' : ''

			query += `&sort=${order}${sorter.field}`
		}

		API.get(`/api/inventory?page=${page}${query}&include[]=user&include[]=product&include[]=sourceWarehouse&include[]=targetWarehouse`)
			.then(response => {
				this.setState({
					data: response.data.data,
					pagination: {
						...this.state.pagination,
						total: response.data.total
					},
					loading: false
				})
			})
			.catch(() => {
				this.setState({
					loading: false
				})
			})
	}

	handleTableChange = (pagination, filters, sorter) => {
		const pager = { ...this.state.pagination }
		pager.current = pagination.current

		this.setState({
			pagination: pager,
			loading: true
		})

		this.getData({
			page: pagination.current,
			filters,
			sorter
		})
	}

	render() {
		const columns = [
			{
				title: 'ID',
				dataIndex: 'id'
            },
            {
				title: 'Tipo',
                dataIndex: 'type',
                render: (label, record) => {
                    let response;
                    switch(record.type) {
                        case 'receipt':
                            response = <Tag color={'green'} key={record.type}>Entrada <Icon type="arrow-right" /></Tag>
                            break;

                        case 'transfer':
                            response = <Tag color={'volcano'} key={record.type}>Transferencia <Icon type="swap" /></Tag>
                            break;

                        case 'exit':
                            response = <Tag color={'gold'} key={record.type}>Salida <Icon type="swap" /></Tag>
                            break;

                        case 'sale':
                            response = <Tag color={'geekblue'} key={record.type}>Venta <Icon type="swap" /></Tag>
                            break;

                        default:
                            break;
                    }
                    return response;
                }
			},
			{
				title: 'Product',
                dataIndex: 'product_id',
                render: (label, record) => {
                    return record.product ? record.product.name : record.product_id;
                }
				// sorter: true,
				// ...this.getColumnSearchProps('name')
			},
			// {
			// 	title: 'Activo',
			// 	dataIndex: 'active',
			// 	render: (label, record) => (record.active ? 'Si' : 'No'),
			// 	filterMultiple: false,
			// 	filters: [
			// 		{ text: 'Activo', value: 1 },
			// 		{ text: 'No activo', value: 0 }
			// 	],
            //     sorter: true,
            // },
            {
                title: 'Desde el Almacen',
                dataIndex: 'source_warehouse_id',
                render: (label, record) => {
                    return record.source_warehouse ? record.source_warehouse.name : record.source_warehouse_id;
                }
            },
            {
                title: 'Para el Almacen',
                dataIndex: 'target_warehouse_id',
                render: (label, record) => {
                    return record.target_warehouse ? record.target_warehouse.name : record.target_warehouse_id;
                }
            },
            {
                title: 'Cantidad',
                dataIndex: 'quantity',
            },
			{
				title: 'Fecha Creacion',
				dataIndex: 'created_at',
                sorter: true,
				// render: (label, record) => record.currency.code,
			},
			// {
			// 	title: 'Acciones',
			// 	dataIndex: '',
			// 	key: 'x',
			// 	render: () => {
			// 		return (
			// 			<div>
			// 				<Button
			// 					type="primary"
			// 					shape="circle"
			// 					icon="edit"
			// 					size="small"
			// 					style={{ margin: 5 }}
			// 				/>
			// 				<Button
			// 					type="primary"
			// 					shape="circle"
			// 					icon="info-circle"
			// 					size="small"
			// 				/>
			// 			</div>
			// 		)
			// 	}
			// }
		]

		return (
			<div>
				<div style={{ display: 'flex', padding: '16px 0' }}>
					<span style={{ flex: 1 }}> Reporte de Inventario </span>
					<Tooltip title="Entrada Inventario" placement="left">
						<Button
							type="primary"
							shape="circle"
							icon="plus"
							onClick={() =>
								this.props.history.push('/inventory/entry')
							}
						/>
					</Tooltip>
				</div>

				<div
					style={{
						backgroundColor: 'white',
						borderRadius: 3,
						padding: 16
					}}
				>
					<Table
						columns={columns}
						rowKey={record => record.id}
						dataSource={this.state.data}
						pagination={this.state.pagination}
						loading={this.state.loading}
						onChange={this.handleTableChange}
						bordered
						size="small"
					/>
				</div>
			</div>
		)
	}
}

export default InventoryEntryReport
